<mat-sidenav-container class="navbar-sidenav-container">
  <mat-sidenav
    #drawer
    class="navbar-sidenav"
    mode="over"
    position="end"
    fixedInViewport="true"
    [autoFocus]="false"
  >
    <div class="navbar-sidenav-content">
      <div class="navbar-sidenav-header">
        <button mat-icon-button class="navbar-close-btn" (click)="drawer.close()" aria-label="Close navigation">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" (click)="navigateToHome(); drawer.close()" style="cursor: pointer;">Home</a>
        </li>
        @if (isLoggedIn()) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/my-bookings" (click)="drawer.close()">My Bookings</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/my-profile" (click)="drawer.close()">My Profile</a>
          </li>
        }
        <li class="nav-item">
          <a class="nav-link" routerLink="/terms" (click)="drawer.close()">Terms & Conditions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/cancellation" (click)="drawer.close()">Cancellation Policy</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/privacy" (click)="drawer.close()">Privacy Policy</a>
        </li>
        @if (!isLoggedIn()) {
          <li class="nav-item sidenav-login-btn">
            <button mat-button class="login-btn" (click)="showLoginForm(); drawer.close()">Login</button>
          </li>
        } @else {
          <li class="nav-item sidenav-logout-btn">
            <button mat-button class="logout-btn" (click)="logout(); drawer.close()">Logout</button>
          </li>
        }
      </ul>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="navbar">
      <div class="navbar-left">
        <div class="navbar-brand" (click)="navigateToHome()" style="cursor: pointer;">
         
          <div class="brand-container">
            @if (isLoading()) {
              <div class="logo-loading">
                <mat-icon>refresh</mat-icon>
              </div>
            } @else if (error() || !logoIsValid()) {
              <img src="assets/my_fleetman_logo.svg" alt="MyFleetMan Logo" class="logo-img logo-square" />
            } @else {
              <img 
                [src]="logoUrl()" 
                alt="Company Logo" 
                class="logo-img"
                [class]="logoCssClass()"
                (error)="onLogoError()"
                (load)="onLogoLoad()"
              />
            }
            <div class="brand-text">
              <div class="company-name">{{ companyName() }}</div>
              <div class="company-tagline">Car Rental Software</div>
            </div>
          </div>
        </div>
      </div>
      <span class="spacer"></span>
      <!-- Desktop links -->
      <nav class="navbar-links">
        <a class="nav-link" (click)="navigateToHome()" style="cursor: pointer;" [class.active]="router.url === '/' || router.url === '/home'">Home</a>
        @if (isLoggedIn()) {
          <a class="nav-link" routerLink="/my-bookings" routerLinkActive="active">My Bookings</a>
          <!-- <a class="nav-link" routerLink="/my-profile" routerLinkActive="active">My Profile</a> -->
        }
        <a class="nav-link" routerLink="/terms" routerLinkActive="active">Terms & Conditions</a>
        <a class="nav-link" routerLink="/cancellation" routerLinkActive="active">Cancellation Policy</a>
        <a class="nav-link" routerLink="/privacy" routerLinkActive="active">Privacy Policy</a>
        
        @if (!isLoggedIn()) {
          <button mat-button class="login-btn" (click)="showLoginForm()">Login</button>
        } @else {
          <div class="user-menu-container">
            <button mat-button [matMenuTriggerFor]="userMenu" class="user-menu-btn">
              <mat-icon>account_circle</mat-icon>
              <span class="user-name">{{ userDisplayName() }}</span>
              <mat-icon>expand_more</mat-icon>
            </button>
            <mat-menu #userMenu="matMenu" class="user-menu">
              <button mat-menu-item routerLink="/my-profile">
                <mat-icon>person</mat-icon>
                <span>My Profile</span>
              </button>
              <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
              </button>
            </mat-menu>
          </div>
        }
      </nav>
      <!-- Hamburger for mobile -->
      <button mat-icon-button class="navbar-toggler" (click)="drawer.open()" aria-label="Toggle navigation">
        <mat-icon>menu</mat-icon>
      </button>
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container> 